import { CompoundEntityRef, stringifyEntityRef } from '@backstage/catalog-model'
import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api'
import { AwsLambda } from '@internal/backstage-plugin-veho-backstage-common'

import { AwsLambdaApi } from './AwsLambdaApi'

export class AwsLambdaApiClient implements AwsLambdaApi {
  private readonly discoveryApi: DiscoveryApi
  private readonly fetchApi: FetchApi

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi
    this.fetchApi = options.fetchApi
  }

  async getLambdasByEntity(entityRef: CompoundEntityRef): Promise<AwsLambda[]> {
    const baseUrl = await this.discoveryApi.getBaseUrl('aws-lambda')

    const { namespace, kind, name } = entityRef
    const url = `${baseUrl}/v1/entity/${namespace}/${kind}/${name}/lambda`

    const response = await this.fetchApi.fetch(url)

    if (!response.ok) {
      throw new Error(`Failed to fetch lambdas for entity ${stringifyEntityRef(entityRef)}: ${response.statusText}`)
    }

    return response.json()
  }
}
